import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("polygon", {
		className: "icon-fill-primary",
		points: "36.3 42.1 27.8 40.6 13.1 40.6 38.3 45 39.1 40.6 36.5 40.6"
	}), /* @__PURE__ */ _jsx("path", {
		className: "icon-fill-primary",
		d: "M6.7.1L.8 33.5h2.5l4-23 33.4 5.8-3 17.3h2.6L45 6.7 6.7.1zm19.9 6l6.5 1.1-.9 5-6.5-1.1.9-5zm-3.3 4.6l-6.5-1.1.9-5 6.5 1.1-.9 5zM8.7 3l6.5 1.1-.9 5L7.8 8l.9-5zm26 9.7l.9-5 6.5 1.1-.9 5-6.5-1.1z"
	})] }), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("rect", {
			y: 35.8,
			className: "icon-fill-secondary",
			width: 5.4,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7.9,
			y: 35.8,
			className: "icon-fill-secondary",
			width: 5.4,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 15.8,
			y: 35.8,
			className: "icon-fill-secondary",
			width: 5.4,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 23.8,
			y: 35.8,
			className: "icon-fill-secondary",
			width: 5.4,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 31.7,
			y: 35.8,
			className: "icon-fill-secondary",
			width: 5.4,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 39.6,
			y: 35.8,
			className: "icon-fill-secondary",
			width: 5.4,
			height: 2.5
		})
	] })]
});
export default SvgIcon;
